<template>
<div class="EquityLearning">
    <div class="banner">
        <div class="page-module">
            <div class="card-left">
                <p class="name animated fadeInUp">股权学习</p>
                <p class="msg animated fadeInUp">线上课程 、线下课程自由选择，深入了解股权知识</p>
                <div class="button animated fadeInUp">
                    <button class="btn-style" @click="goto()">留言咨询<div class="line"></div></button>
                </div>
            </div>
            <div class="card-right">
                <img class="img-1 animated fadeInUp" src="~common/images/gujing/equityLearning/banner-bg.png" alt="1">
                <img class="img-2 animated fadeInUp" src="~common/images/gujing/equityLearning/banner-bg_1.png" alt="1">
                <img class="img-3 animated fadeInUp" src="~common/images/gujing/equityLearning/banner-bg_2.png" alt="1">
                <img class="img-4 animated fadeInUp" src="~common/images/gujing/equityLearning/banner-bg_3.png" alt="1">
                <img class="img-5 animated fadeInUp" src="~common/images/gujing/equityLearning/banner-bg_4.png" alt="1">
                <img class="img-6 animated fadeInUp" src="~common/images/gujing/equityLearning/banner-bg_5.png" alt="1">
            </div>
        </div>
    </div>
    <!-- end banner -->
    <div class="student item">
        <div class="page-module animated">
            <p class="name">线上课堂</p>
            <div class="recommend_box">
                <div v-for="(item, index) in recommendCourseData" :key="index">
                    <div @click="courseClick(item)" v-if="index < 3" :class="{'recommend__item_div': true, 'margin-0': index == 0}" >
                        <div class="img">
                            <img v-lazy="item.coverurl" alt="">
                        </div>
                        <p>{{item.subject}}</p>
                    </div>
                </div>
            </div>
            <el-button type="text" @click="courseClickMore">查看更多<img src="~common/images/gujing/equityLearning/icon-more.png" alt="1"></el-button>
        </div>
    </div>
    <!-- end 线上课堂 -->
    <div class="xx-student bg-F5F7FA">
        <div class="page-module animated">
            <p class="name">线下课程</p>
            <img src="~common/images/gujing/equityLearning/current.png" alt="1">
        </div>
    </div>
    <!-- end 线下课程 -->
     <div class="item-1 item bg-F5F7FA">
        <div class="page-module animated">
            <div class="left-content">
                <p class="name">课程对象</p>
                <div class="msg">
                    <p>企业股东、董事长、总经理、核心高层管理者等</p>
                    <p>人力资源总监、法律顾问等企业股权事务负责人</p>
                    <p>关注创业、加盟、投融资过程股权事宜相关人士</p>
                </div>
            </div>
            <div class="right-img">
                <img class="img-1" src="~common/images/gujing/equityLearning/item_1.png" alt="1">
            </div>
        </div>
    </div>
    <!-- end 课程对象 -->
    <div class="item-2 item">
        <div class="page-module animated">
            <div class="left-content">
                <p class="name">课程特色</p>
                <div class="msg">
                    <p class="type">全面</p>
                    <p>从股权结构、员工持股、股权融资等多方面介绍股权运用相关注意事项</p>
                    <p class="type">实战</p>
                    <p>小班教学、咨询式培训，资深咨询师独立深入的一对一辅导交流</p>
                    <p class="type">权威</p>
                    <p>5000多家企业服务经验沉淀，华为、温氏等股权激励成功经验借鉴</p>
                </div>
            </div>
            <div class="right-img">
                <img class="img-1" src="~common/images/gujing/equityLearning/item_2.png" alt="1">
            </div>
        </div>
    </div>
    <!-- end 课程特色 -->

    <div class="outline bg-F5F7FA">
        <div class="page-module animated">
            <p class="name">课程大纲</p>
            <div class="content">
                <div class="left-card">
                    <div class="bg-img">
                        <ul>
                            <li>
                                <p>{{leftCard[indexactive]}}</p>
                            </li>
                        </ul>
                    </div>
                </div> 
                <div class="right-menu">
                    <ul>
                        <li v-for="(item, index) in rightMenu" :key="index" :class="{'active': indexactive == index}" @mousemove="indexactive = index">{{item}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- end 课程大纲 -->

    <LeavingAMessage :code="'A01'"></LeavingAMessage>
    <!-- end 留言 -->

    <div class="telme">
        <p>13556826075</p>
        <img src="~common/images/gujing/equityLearning/lxwo.png" alt="lxwm" width="50px">
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {getRecommendCourse} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import LeavingAMessage from '../components/LeavingAMessage.vue'
import "animate.css/animate.min.css"
export default {
    name: 'EquityLearning',
    data() {
        return {
            recommendCourseData: [],
            rightMenu: ['第一章 股权的价值与内涵', '第二章 创业合伙股权注意事项', '第三章 股权融资注意事项', '第四章 股权激励方案设计'],
            leftCard: ['股权的定义与本质、股权分配的智慧、股权的价值与风险','股权生命线深度解读、常见股权结构分析、创业合伙常见股权问题应对',
            '常见的几种企业估值方法、控制权与股份稀释比例探究、融资协议中重点注意条款','股权激励的三种模式、股权持股模式的优缺点比较、股权激励方案设计6大要素'],
            indexactive: 0
        }
    },
    //判断pc或者移动，然后路由跳转
    created() {
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MEquityLearning'
            })
        }
    },
    mounted() {
        if (!this.isIE()) {
            $('.gj-footer').css("margin-top","0")
        }
        this.findRecommendCourse()
        $('html').scrollTop(0)
        $(".gj_header").addClass('gj_top_header')
        if (this.animationScrool) {
            window.addEventListener('scroll', this.animationScrool)
        }
        this.animationScrool()
        $(window).bind("scroll",function(){  
            if (this.animationScrool) {
                this.animationScrool()
            }
        });
    },
    methods: {
        animationScrool() { // 鼠标滚动事件监控，进行动画 top 动画事件
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            // console.log(scrollTop)
            // 添加滚动条
            if (this.$route.name == "EquityLearning") {
                if (scrollTop > 10) {
                    if ($(".gj_header").hasClass('gj_top_header')) {
                        $(".gj_header").removeClass('gj_top_header')
                    }
                }
                if (scrollTop == 0) {
                    $(".gj_header").addClass('gj_top_header')
                }
            }

            if (scrollTop >= 0 && scrollTop < 900) {
                if (!$(".student  .page-module").hasClass('fadeInUp')) {
                    $(".student .page-module").addClass('fadeInUp')
                }
            }
             if (scrollTop > 320 && scrollTop < 1390) {
                if (!$(".xx-student  .page-module").hasClass('fadeInUp')) {
                    $(".xx-student .page-module").addClass('fadeInUp')
                }
            }

            if (scrollTop > 780 && scrollTop < 1850) {
                if (!$(".item-1 .page-module").hasClass('fadeInUp')) {
                    $(".item-1 .page-module").addClass('fadeInUp')
                }
            }
            if (scrollTop > 1200 && scrollTop < 2340) {
                 if (!$(".item-2 .page-module").hasClass('fadeInUp')) {
                    $(".item-2 .page-module").addClass('fadeInUp')
                }
            }
            if (scrollTop > 1700 && scrollTop < 2950) {
                 if (!$(".outline  .page-module").hasClass('fadeInUp')) {
                    $(".outline  .page-module").addClass('fadeInUp')
                }
             }
            if (scrollTop > 2300) {
                 if (!$(".LeavingAMessage .page-module").hasClass('fadeInUp')) {
                    $(".LeavingAMessage .page-module").addClass('fadeInUp')
                }
             }
            
        },
        goto() {    // 跳转
            // if (this.user.isLogin) {
                // 跳转到估值页面
                // this.$router.push({name: 'ExcitationStep'})
                $('html').scrollTop(3000)
            // } else {
                // 登录弹窗
                // this.setLoginPop(true)
            // }
        },
        // 点击推荐课程
        courseClick(val) {
            // window.open(`http://local.ke.capwhale.com:6001/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}`)
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}&chid=${this.channelid}`)
            } else {
                window.open(`${this.domainlist.url_course}/coursedetails?cid=${val.courseid}&chid=${this.channelid}`)
            }
        },
         // 点击查看更多课程 
         courseClickMore() {
            // window.open(`http://local.ke.capwhale.com:6001/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}`)
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/pindex?token=${this.user.loginToken}&chid=${this.channelid}`)
            } else {
                window.open(`${this.domainlist.url_course}/pindex?chid=${this.channelid}`)
            }
        },
        // 获取股鲸推荐课程
        findRecommendCourse() {
            this.setLoading(true)
            let params = {}
            getRecommendCourse({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.recommendCourseData = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        isIE() { //ie?  
            if (!!window.ActiveXObject || "ActiveXObject" in window) { return true; }  
            else { return false; }  
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'domainlist',
            'domainInfo',
            'channelid'
        ])
    },
    destroyed() {
        $('.gj-footer').css("margin-top","40px")
        $(".gj_header").removeClass('gj_top_header')
    },
    components: {
        LeavingAMessage
    }
}
</script>
<style lang="scss" type="text/scss" scoped>
.EquityLearning {
    background: #fff;
    // background-color: rgb(225, 236, 193);
    // padding-top: 64px;
    .banner {
        height: 500px;
        background: url('../../../common/images/gujing/gz/banner-bg.png') no-repeat center;
        background-size: 1920px 500px;

        .card-left {
            float: left;
            margin-top: 114px;
            p {
                color: #fff;
            }
            .name {
                font-size: 40px;
                font-weight:500;
                text-align: left;
                &::before {
                    content: '';
                    display: none;
                }
            }
            .msg {
                margin-top: 37px;
                font-size: 20px;
            }
            .button {
                width: 180px;
                
                .btn-style {
                    position: relative;
                    overflow: hidden;
                    margin-top: 60px;
                    width:180px;
                    height:50px;
                    background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -webkit-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -ms-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -moz-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -o-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    border-radius:25px;
                    border: none;
                    cursor: pointer;
                    color: #fff;
                    font-size: 20px;

                    &:hover {
                        .line {
                            left: 160px;
                            transition: all .6s;
                            -webkit-transition: all .6s;
                            -ms-transition: all .6s;
                            -o-transition: all .6s;
                            -moz-transition: all .6s;
                        }
                    }
                    .line {
                        position: absolute;
                        width: 100px;
                        height: 25px;
                        background: rgba(255,255,255,.3);
                        transform: rotateZ(45deg);
                        bottom: 15px;
                        left: -80px;
                        transition: all 0;
                        -webkit-transition: all 0;
                        -ms-transition: all 0;
                        -o-transition: all 0;
                        -moz-transition: all 0;
                    }
                }
            }
        }
        .card-right {
            float: right;
            position: relative;
            margin-top: 89px;
            margin-right: 45px;
            width: 470px;
            height: 376px;
            .img-1 {
                width: 100%;
                height: 100%;
            }
            .img-2 {
                position: absolute;
                left: 180px;
                top: 38px;
                width: 89px;
                height: 124px;
                animation: imganimation 2s;
                -webkit-animation: imganimation 2s;
                -ms-animation: imganimation 2s;
                -moz-animation: imganimation 2s;
                -o-animation: imganimation 2s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
            .img-3,
            .img-4,
            .img-5,
            .img-6 {
                position: absolute;
                
            }
            .img-3 {
                width: 59px;
                height: 44px;
                top: 110px;
                left: 30px;
                animation: imganimation4 1s;
                -webkit-animation: imganimation4 1s;
                -ms-animation: imganimation4 1s;
                -moz-animation: imganimation4 1s;
                -o-animation: imganimation4 1s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
            .img-4 {
                width: 54px;
                height: 41px;
                top: 105px;
                right: 60px;
                animation: imganimation3 1.5s;
                -webkit-animation: imganimation3 1.5s;
                -ms-animation: imganimation3 1.5s;
                -moz-animation: imganimation3 1.5s;
                -o-animation: imganimation3 1.5s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
            .img-5 {
                width: 46px;
                height: 42px;
                top: 225px;
                left: 40px;
                animation: imganimation2 1.8s;
                -webkit-animation: imganimation2 1.8s;
                -ms-animation: imganimation2 1.8s;
                -moz-animation: imganimation2 1.8s;
                -o-animation: imganimation2 1.8s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
            .img-6 {
                width: 50px;
                height: 44px;
                top: 225px;
                right: 60px;
                animation: imganimation2 2.5s;
                -webkit-animation: imganimation2 2.5s;
                -ms-animation: imganimation2 2.5s;
                -moz-animation: imganimation2 2.5s;
                -o-animation: imganimation2 2.5s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
            @keyframes imganimation4 {
                0% {
                    top: 112px;
                }
                100% {
                    top: 110px;
                }
            }
             @keyframes imganimation3 {
                0% {
                    top: 108px;
                }
                100% {
                    top: 105px;
                }
            }
            @keyframes imganimation2 {
                0% {
                    top: 235px;
                }
                100% {
                    top: 225px;
                }
            }
            @keyframes imganimation {
                0% {
                    top: 38px;
                }
                100% {
                    top: 28px;
                }
            }
        }
    }
    .student {
        .page-module {
            opacity: 0;
        }
        text-align: center;
        .el-button {
            margin-top: 30px;
            font-size: 16px;
            color: #666666;
            img {
                display: inline-block;
                width: 8px;
                height: 14px;
                margin-left: 10px;
                vertical-align: -2px;
            }
        }
    }
    .bg-F5F7FA {
        background: #F5F7FA;
    }
    .xx-student {
        padding: 60px 0;
        .page-module {
            opacity: 0;
        }
        img {
            margin: auto;
            margin-top: 52px;
            width: 1180px;
        }
    }
    .name {
                position: relative;
                text-align: center;
                padding: 10px 0;
                font-size: 26px;
                color: #333;
                &::before {
                    content: '';
                    position: absolute;
                    margin: auto;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width:36px;
                    height:2px;
                    background: #409EFF;
                }
        }

    
    
    .item {
        padding: 56px 0 77px 0;
        .animated {
            opacity: 0;
        }
        .fadeInUp {
            opacity: 1;
        }
        .left-content {
            float: left;
            width: 570px;
            .name {
                position: relative;
                font-size: 26px;
                color: #333;
                text-align: left;
                &::before {
                    content: '';
                    position: absolute;
                    margin: 0;
                    bottom: -10px;
                    width:36px;
                    height:2px;
                    background: #409EFF;
                }
            }
            .msg {
                margin-top: 38px;
                font-size: 16px;
                color: #666;
                line-height: 24px;
            }
        }
        .right-img {
            float: left;
            margin-left: 134px;
            img {
                width: 318px;
                height: 237px;
            }
        }
        &.item-1 {
            padding: 44px 0 44px 0;
            img {
                width: 520px;
                height: 353px;
            }
            .msg {
                p {
                    margin-bottom: 20px;
                    padding-left: 30px;
                    font-size: 16px;
                    color: #666;
                    background: url("../../../common/images/gujing/equityLearning/icon_active.png") no-repeat;
                    background-size: 20px 20px;
                    background-position-x: left;
                    background-position-y: center;
                }
            }
            .right-img {
                float: right;
                margin-left: 50px;
            }
            .left-content {
                margin-top: 59px;
            }
        }
        &.item-2 {
            padding: 43px 0 43px 0;
            img {
                width: 481px;
                height: 354px;
            }
            .msg {
                p {
                    font-size: 16px;
                    color: #666;
                    margin-bottom: 10px;
                    &.type {
                        font-size: 20px;
                        color: #409EFF;
                    }
                }
            }
            .left-content {
                float: right;
                margin-top: 72px;
            }
            .right-img {
                margin-left: 0
            }
        }
        &.item-3 {
            padding: 33px 0;
            img {
                width: 461px;
                height: 305px;
            }
            .right-img {
                float: right;
            }
            .left-content {
                margin-top: 84px;
            }
        }
    }
    .margin-0 {
        margin-left: 0 !important;
    }
    .recommend_box {
        margin-top: 67px;
        width: 1180px;
            // display: flex;
            .recommend__item_div {
                float: left;
                margin-left: 30px;
                margin-bottom: 10px;
                width: 366px;
                height: 312px;
                box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                cursor: pointer;

                &>.img {
                    width: 366px;
                    height: 207px;
                    overflow: hidden;
                    background: #ccc;
                    cursor: pointer;
                    border-radius: 4px 4px 0 0;
                    img {
                        width: 100%;
                        height: 100%;
                        transition: all .5s;
                        -webkit-transition: all .5s;
                        -ms-transition: all .5s;
                        -moz-transition: all .5s;
                        -o-transition: all .5s;
                        // width: 366px;
                        // height: 207px;
                        // cursor: pointer;
                        // background: #ccc;
                    }
                }
                &:hover {
                    img {
                        transform: scale(1.2);
                        -webkit-transform: scale(1.2);
                        -ms-transform: scale(1.2);
                        -moz-transform: scale(1.2);
                        -o-transform: scale(1.2);
                        transition: all .5s;
                        -webkit-transition: all .5s;
                        -ms-transition: all .5s;
                        -moz-transition: all .5s;
                        -o-transition: all .5s;
                    }
                    p {
                        color: #409EFF;
                        transition: all .5s;
                        -webkit-transition: all .5s;
                        -ms-transition: all .5s;
                        -moz-transition: all .5s;
                        -o-transition: all .5s;
                    }
                }
                &>p {
                    margin: 25px 23px;
                    box-sizing: border-box;
                    text-align: justify;
                    cursor: pointer;
                    font-size: 20px;
                    line-height:28px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    transition: all .5s;
                    -webkit-transition: all .5s;
                    -ms-transition: all .5s;
                    -moz-transition: all .5s;
                    -o-transition: all .5s;
                }
                
            }
            
            
    }
    .outline {
        padding: 60px 0;
        .page-module {
            opacity: 0;
        }
        .content {
            height: 446px;
            margin-top: 67px;
            .left-card {
                float: left;
                position: relative;
                width: 710px;
                height: 446px;
                background: url("../../../common/images/gujing/equityLearning/item_3.png") no-repeat;
                background-size: 710px 446px;
                li {
                    position: absolute;
                    margin: auto;
                    left: 0;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    -webkit-transform: translateY(-50%);
                    -ms-transform: translateY(-50%);
                    -moz-transform: translateY(-50%);
                    -o-transform: translateY(-50%);
                    // margin-top: 181px;
                    // margin-left: 146px;
                    width: 420px;
                    p {
                        color: #fff;
                        font-size: 24px;
                        line-height: 38px;
                    }
                }
            }

        }
        .right-menu {
            float: left;
            margin-left: 10px;
            width: 420px;
            height: 446px;
            li {
                padding: 35px 35px 32px 35px;
                height:100px;
                box-sizing: border-box;
                background:rgba(255,255,255,1);
                border-radius:4px;
                font-size: 24px;
                color: #666666;
                transition: all .5s;
                -webkit-transition: all .5s;
                -ms-transition: all .5s;
                -moz-transition: all .5s;
                -o-transition: all .5s;
                cursor: pointer;
                
                &.active,
                &:hover {
                    color: #409EFF;
                    box-shadow:0px 0px 20px 0px rgba(48,49,51,0.2);
                    -webkit-box-shadow:0px 0px 20px 0px rgba(48,49,51,0.2);
                    -ms-box-shadow:0px 0px 20px 0px rgba(48,49,51,0.2);
                    -moz-box-shadow:0px 0px 20px 0px rgba(48,49,51,0.2);
                    -o-box-shadow:0px 0px 20px 0px rgba(48,49,51,0.2);
                    transition: all .5s;
                    -webkit-transition: all .5s;
                    -ms-transition: all .5s;
                    -moz-transition: all .5s;
                    -o-transition: all .5s;
                }
                &~li {
                    margin-top: 15px;
                }
            }
        }
    }
    .telme {
        position: fixed;
        z-index: 2;
        box-sizing: border-box;
        right: 0;
        bottom: 50px;
        width: 50px;
        height: 50px;
        background: #409EFF;
        color: #fff;
        font-size: 14px;
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        -moz-transition: all .5s;
        p {
            display: none;
            line-height: 50px;
        }
        &:hover {
            padding: 0 11px;
            line-height: 50px;
            width: 150px;
            font-size: 16px;
            transition: all .6s;
            -webkit-transition: all .6s;
            -ms-transition: all .6s;
            -o-transition: all .6s;
            -moz-transition: all .6s;
            img {
                display: none;
            }
            p {
                display: block;
                padding-left: 25px;
                background: url("../../../common/images/gujing/phone2.png") no-repeat;
                background-position-x: left;
                background-position-y: center;
                background-size: 19px 20px;
            }
        }
    }
    
}
</style>